import React from 'react';
import './PainelParalaxe3.css';

const PainelParalaxe2 = () => {
  return (
    <div className="paralaxe-container3">
      <div className="paralaxe-conteudo3">
        <div className="paralaxe-texto-container3">
          <h2 className="paralaxe-titulo3">Conforto na sua medida</h2>
          <p className="paralaxe-texto3">
            Transformamos sua casa trazendo design funcional e beleza para criar um ambiente aconchegante e agradável.
             Cada projeto é executado com o máximo de profissionalismo e cuidado, desde o primeiro rascunho até a instalação final,
              cada detalhe contribuindo para o seu bem-estar e satisfação. 
          </p>
        </div>
      </div>
    </div>
  );
};

export default PainelParalaxe2;